import * as React from 'react';
import { LinkedText } from './LinkedText';

interface AnswerSectionProps {
  paragraphs: string[];
}

export function AnswerSection({ paragraphs }: AnswerSectionProps) {
  return (
    <section className="whyus-answer">
      <style>{`
        .whyus-answer {
          padding: 48px 24px 16px;
          background: #fff;
        }
        .whyus-answer-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .whyus-breadcrumb {
          font-size: 14px;
          color: #777;
          margin: 0 0 20px;
        }
        .whyus-breadcrumb a {
          color: #1EAA25;
          font-weight: 600;
          text-decoration: none;
        }
        .whyus-breadcrumb a:hover {
          text-decoration: underline;
        }
        .whyus-answer p {
          font-size: 17px;
          color: #333;
          line-height: 1.7;
          margin: 0 0 16px;
        }
        @media (max-width: 640px) {
          .whyus-answer p {
            font-size: 16px;
          }
        }
      `}</style>
      <div className="whyus-answer-inner">
        <nav className="whyus-breadcrumb" aria-label="Migas">
          <a href="/">Inicio</a>
          <span> › </span>
          <span>Por qué elegirnos</span>
        </nav>
        {paragraphs.map((paragraph) => (
          <p key={paragraph.slice(0, 48)}>
            <LinkedText text={paragraph} />
          </p>
        ))}
      </div>
    </section>
  );
}
